import { Component } from '@angular/core';

@Component({
  selector: 'app-what-is-ocr-pdf',
  imports: [],
  templateUrl: './what-is-ocr-pdf.component.html',
  styleUrl: './what-is-ocr-pdf.component.css'
})
export class WhatIsOCRPDFComponent {

}
